<app-page-header
  title="Auftragsdetails"
  subtitle="Alle Informationen zu deiner Bestellung"
  icon="receipt_long"
  [showBackButton]="true"
  variant="gradient">
</app-page-header>

<!-- Apple-style Content Grid -->
<div class="apple-slide-up">
  <div class="apple-order-details-grid">
    <!-- Order Widget -->
    <div class="order-widget-section">
      <app-order-widget [gatewayOrder]="gatewayOrder$ | async" [order]="order$ | async"
        [customer]="customer$ | async"></app-order-widget>
    </div>

    <!-- Coin Usage -->
    <div class="coin-usage-section">
      <app-coin-usage [customer]="customer$ | async" [order]="order$ | async" [gatewayOrder]="gatewayOrder$ | async" [(coinsUsed)]="coinsUsed"
        (confirm)="openConfirmDialog()"></app-coin-usage>
      
      <!-- Contact -->
      <app-contact-widget [gatewayOrder]="gatewayOrder$ | async"></app-contact-widget>
    </div>

    <!-- Comments Section (Full Width) -->
    <div class="comments-section">
      <app-order-comments-card [orderId]="(order$ | async)?.id || 0"
        [orderReflexNo]="(gatewayOrder$ | async)?.orderNo || null"></app-order-comments-card>
    </div>

    <!-- Coin Usage History by current order-->
    <div class="coin-usage-history-section">
      <app-coin-usage-history [orderId]="(gatewayOrder$ | async)?.orderNo || ''"></app-coin-usage-history>
    </div>
</div>
